
import { MediaOwnerPricingConstants } from './types';

// Waki pricing constants
export const WAKI_COST_PER_DEVICE_PER_DAY = 25;
export const WAKI_DISCOUNT_SCREENS_THRESHOLD = 35;
export const WAKI_BASE_DISCOUNT_RATE = 0.05;
export const WAKI_MAX_DISCOUNT_RATE = 0.30;

export const wakiPricingConstants: MediaOwnerPricingConstants = {
  costPerDevicePerDay: WAKI_COST_PER_DEVICE_PER_DAY,
  discountScreensThreshold: WAKI_DISCOUNT_SCREENS_THRESHOLD,
  baseDiscountRate: WAKI_BASE_DISCOUNT_RATE,
  maxDiscountRate: WAKI_MAX_DISCOUNT_RATE
};
